import React from 'react';
import HoldingsHeader from './HoldingsHeader';
import HoldingsFooter from './HoldingsFooter';

const HoldingsLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col" data-testid="holdings-layout">
      <HoldingsHeader />
      <main className="flex-1">
        {children}
      </main>
      <HoldingsFooter />
    </div>
  );
};

export default HoldingsLayout;
